<template>
    <TDesktop 
        v-if="isAppLoaded && canStart"
        class="p-desktop desktop"
        :class="{'desktop__focus-supports': isKeyboardNavigation}"
    >
        <template #overlay>
            <div
                class="desktop__overlay"
                v-if="isOverlay"
                @click="isOverlay = false"
            />
        </template>
        <template #header>
            <ODHeader />
        </template>
        <template #sidepanel>
            <router-view />
        </template>
        <template #footer>
            <ODFooter v-if="isFooter"/>
        </template>
        <template #modal>
            <OBaseModal
                v-if="modalOrganism"
                :organism="modalOrganism.component"
                :data="modalOrganism.data"
                @onClose="closeModal"
            />
        </template>
    </TDesktop>
    <AInitialLoader v-else />
</template>

<script>
import '../../../assets/images/generated-svg';

import {
    mapGetters,
    mapActions
} from 'vuex';

import TDesktop from '../../templates/t-desktop/t-desktop';
import ODHeader from '../../organisms/o-d-header/o-d-header';
import ODFooter from '../../organisms/o-d-footer/o-d-footer';
import OBaseModal from '../../organisms/o-modal-base/o-modal-base';
import AInitialLoader from '../../atoms/a-initial-loader/a-initial-loader';

import {
    TYPES,
    WEB_GUIDE,
    MOBILE_GUIDE,
    DESKTOP_START_SCREEN
} from '../../../utils/constants/pages';
import {
    SHOW_MODAL,
    SHOW_OVERLAY
} from '../../../utils/constants/bus-events-constants';

import keyboardNavigation from '../../../utils/mixins/keyboard-navigation';
import canStart from '../../../utils/mixins/can-start';

export default {
    name: 'PDesktop',
    components: {
        ODFooter,
        ODHeader,
        TDesktop,
        OBaseModal,
        AInitialLoader
    },
    mixins: [keyboardNavigation, canStart],
    data() {
        return {
            isOverlay: false,
            modalOrganism: null
        }
    },
    computed: {
        ...mapGetters([
            'isAppLoaded',
            'getDenormalisedObjectById'
        ]),
        isFooter() {
            return this.$route.name.includes(DESKTOP_START_SCREEN);
        }
    },
    watch: {
        isAppLoaded () {
            if(this.isAppLoaded) this.changeLocaleAtStart()
        }
    },
    created() {
        this.$store.commit('setActiveMapTheme', 'desktop');
        this.initEventsListeners();
        this.loadMapData();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        ...mapActions([
            'fetchMapData',
            'changeLocaleAtStart'
        ]),
        async loadMapData() {
            try {
                const mapId = Number(this.$route.params.mapId);
                await this.fetchMapData(mapId);
                if (this.$route.params.qrId) this.proceedQrCodeData();
            } catch(error) {
                console.log('Data fetch error', error);
            }
        },
        initEventsListeners() {
            this.$bus.$on(SHOW_MODAL, this.showModal);
            this.$bus.$on(SHOW_OVERLAY, this.showOverlay);
        },
        deactivateEventsListeners() {
            this.$bus.$off(SHOW_MODAL, this.showModal);
            this.$bus.$off(SHOW_OVERLAY, this.showOverlay);
        },
        showModal(data) {
            this.modalOrganism = data;
        },
        closeModal() {
            this.modalOrganism = null;
        },
        showOverlay(val) {
            this.isOverlay = val;
        },
        proceedQrCodeData() {
            try {
                const qrId = Number(this.$route.params.qrId);
                const qrObj = this.getDenormalisedObjectById(qrId);
                const start = qrObj.meta?.qr.start || '';
                const destination = qrObj.meta?.qr.destination || '';
                const noClosestEntrance = qrObj.meta?.qr.noClosestEntrance || '';
                const params = {
                    name: WEB_GUIDE,
                    params: {
                        type: TYPES.CARE,
                        qr: true
                    },
                    query: {
                        'redirect-from': 'qr'
                    }
                };

                if (!start && !destination) return;

                if (start && destination) {
                    params.query.from = start;
                    params.query.to = destination;
                } else if (start) {
                    params.query.from = start;
                } else if (destination && noClosestEntrance) {
                    params.query.to = destination;
                } else if (destination) {
                    params.query.to = destination;
                    params.params.closest = true;
                }

                this.$router.push(params);
            } catch(error) {
                console.warn('QR code is not valid');
            }
        }
    }
}
</script>

<style lang="scss">
@import "p-desktop";
@import "p-desktop-print";
</style>
